import { createFileRoute } from '@tanstack/react-router'
import { FlaskRound } from 'lucide-react'
import { z } from 'zod'
import { ExperimentsScreen } from '@/screens/improve/SCR-032-experiments'

export const Route = createFileRoute('/_app/w/$ws/experiments')({
  staticData: { screen: {"id":"SCR-032","title":"Evaluation lab","group":"Improve","perm":"simulation.run","order":3,"description":"Compare settings on your own questions before you change anything.", icon: FlaskRound } },
  validateSearch: z.object({
    e: z.string().max(200).optional(),
    run: z.string().max(200).optional(),
    a: z.string().max(200).optional(),
    b: z.string().max(200).optional(),
  }),
  component: ExperimentsScreen,
})
